export const GradientLight = () => {
  return (
    <div className="absolute top-0 left-1/4 w-full h-full aspect-square bg-radial-gradient from-[#28206C] to-[#28206C]/0 to-70% pointer-events-none" />
  );
};
